import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=5a979be2&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=5a979be2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a979be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a979be2')) {
      api.createRecord('5a979be2', component.options)
    } else {
      api.reload('5a979be2', component.options)
    }
    module.hot.accept("./CardDetails.vue?vue&type=template&id=5a979be2&scoped=true", function () {
      api.rerender('5a979be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseFlow/CardDetails.vue"
export default component.exports